// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a0ce6c65","692":"30459736"}[chunkId] + ".chunk.js";
};